module.exports = __webpack_public_path__ + "a7c6279d3803f6237aea1bc8fa8d4ef0.MP3";